import { defineMessages } from 'react-intl'

export default defineMessages({
  placeholder: {
    id: 'components.Capture.placeholder',
    defaultMessage: 'Verification code',
    description: 'placeholder',
  },
  errorMsg: {
    id: 'components.Capture.errorMsg',
    defaultMessage: 'Verification code required.',
    description: 'errorMsg',
  },
})
